module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"text-not-recorded":"Noch nicht erfasst"},"fr":{"text-not-recorded":"Pas encore saisi"},"it":{"text-not-recorded":"Non ancora registrato"}}')
  delete Component.options._Ctor
}
